import React, { useEffect, useRef, useState, useMemo } from 'react';
import styles from '@stylesheet';
import { Text, View, useWindowDimensions } from 'react-native';
import DefaultScreen from '@components/Global/DefaultScreenView';
import UserTable from './UserTable';

const UserActivity = () => {
  const { width, height } = useWindowDimensions();

  const chartConfig = useMemo(() => ({
    backgroundGradientFromOpacity: 0.6,
    backgroundGradientFrom: '#ececec',
    backgroundGradientTo: 'white',
    backgroundGradientToOpacity: 1,
    fillShadowGradient: 'white',
    fillShadowGradientFrom: 'rgb(90,192,234)',
    fillShadowGradientTo: "#0400e9",
    fillShadowGradientToOffset: 9,
    fillShadowGradientOpacity: .7,
    decimalPlaces: 0,
    color: (opacity = 1) => `grey`,
    linejoinType: 'bevel',
    propsForLabels: { fontWeight: '400', fontSize: 12 },
    labelColor: (opacity = 1) => `black`,
    style: {
      borderRadius: 25,
      elevation: 1,
      shadowRadius: 50,
      shadowOffset: { height: 1, width: -1 },
      zIndex: 3,
      overflow: 'hidden',
      paddingTop: 20,
      flex: 1,
    },
    propsForBackgroundLines: { strokeWidth: "0.4", stroke: '#ffa726', opacity: 0.8 },
  }), []);


  return (
    <DefaultScreen style={{ flex: 1 }}>
      <View style={{ flex: 1, minWidth: "100%" }}>
        <UserTable />
      </View>
    </DefaultScreen >
  )
}
export default UserActivity;